import type { EmployeePersonalInformationDto } from "@/generated/model/employeePersonalInformationDto";
import { useProfileSectionEditing } from "@/hooks/use-profile-section-form";
import { formatProfileDate, textOrNotRecorded, yesNo } from "@/lib/people";

import { EditPersonalInformationForm } from "../forms/EditPersonalInformationForm";
import { ProfileSectionCard } from "../ProfileSectionCard";
import { ProfileSectionEditButton } from "../ProfileSectionEditButton";

interface PersonalInformationSectionProps {
  nurseryId: string;
  userId: string;
  personalInformation: EmployeePersonalInformationDto;
  canEdit: boolean;
}

export function PersonalInformationSection({
  nurseryId,
  userId,
  personalInformation,
  canEdit,
}: PersonalInformationSectionProps) {
  const { editing, editButtonRef, startEditing, stopEditing } =
    useProfileSectionEditing();

  return (
    <ProfileSectionCard
      title="Personal information"
      testId="profile-section-personal-information"
      action={
        canEdit &&
        !editing && (
          <ProfileSectionEditButton
            ref={editButtonRef}
            section="personal information"
            onClick={startEditing}
          />
        )
      }
      editForm={
        canEdit &&
        editing && (
          <EditPersonalInformationForm
            nurseryId={nurseryId}
            userId={userId}
            personalInformation={personalInformation}
            onDone={stopEditing}
          />
        )
      }
      fields={[
        {
          label: "Date of birth",
          value: formatProfileDate(personalInformation.dateOfBirth),
        },
        {
          label: "Nationality",
          value: textOrNotRecorded(personalInformation.nationality),
        },
        {
          label: "National Insurance number",
          value: textOrNotRecorded(personalInformation.nationalInsuranceNumber),
        },
        {
          label: "Place of birth",
          value: textOrNotRecorded(personalInformation.placeOfBirth),
        },
        {
          label: "Preferred language",
          value: textOrNotRecorded(personalInformation.preferredLanguage),
        },
        {
          label: "Driving licence holder",
          value: yesNo(personalInformation.drivingLicenceHolder),
        },
        {
          label: "DBS check enforcement date",
          value: formatProfileDate(personalInformation.dbsCheckEnforcementDate),
        },
      ]}
    />
  );
}
